<template>
  <div class="products-groups">
    <PageTitle
      title="группы товаров внешнеторгового оборота"
      subtitle="Всего"
      :subtitleNumber="getTotalGoods"
      classListInfo="list-info-in-count--m0"
    >
      <template v-slot:button>
        <ButtonComponent @click="createCard" mod="gradient-bg">Создать</ButtonComponent>
      </template>
    </PageTitle>

    <div class="table-sort">
      <div class="table-sort__head">
        <TableHeader
          columnCode="Код ТН ВЭД"
          columnNameProduct="Наименование товара"
          columnTradeType="Тип торговой операции"
          columnDepartureCountry="Страна отправления"
          columnDestinationCountry="Страна назначения"
          columnStatus="Статус"
          columnDateCreation="Дата создания"
          columnDateChange="Дата изменения"
          :publicSortColumn="sortColumn"
          :publicSortOrder="sortOrder"
          v-model:codeFilter="filter.codeTnved"
          v-model:nameProductFilter="filter.nameTnved"
          v-model:tradeTypeFilter="filter.tradingOperationId"
          v-model:departureCountryFilter="filter.countryDepartureIds"
          v-model:destinationCountryFilter="filter.countryDestinationIds"
          v-model:statusFilter="filter.isActive"
          v-model:dateCreationFromFilter="filter.createdFrom"
          v-model:dateCreationToFilter="filter.createdTo"
          v-model:dateChangeFromFilter="filter.modifiedFrom"
          v-model:dateChangeToFilter="filter.modifiedTo"
          @changeSorting="changeSorting"
          @changeFilterDepartureCountry="changeFilterDepartureCountry"
          @changeFilterDestinationCountry="changeFilterDestinationCountry"
        />
      </div>
      <div v-if="getTableInfo.items.length && !getLoadPage" class="table-sort__body">
        <div
          class="table-sort__row hover"
          v-for="(item, index) in getTableInfo.items"
          :key="item.id"
          @dblclick="editCard(item.id)"
        >
          <div class="table-sort__td column-icon">
            <div class="wrap-icon">
              <IconComponent class="icon--full-svg" @click="editCard(item.id)" name="edit" />
              <IconComponent
                class="icon--full-svg delete"
                @click="openClarifyingPopup(item.id)"
                name="delete-not-fill"
              />
            </div>
          </div>
          <div class="table-sort__td column-number">
            <p>{{ getTableInfo.firstItemNumber + index }}</p>
          </div>
          <div class="table-sort__td column-code">
            <p>{{ item.tnvedCode }}</p>
          </div>
          <div class="table-sort__td column-name-product">
            <p>{{ item.tnvedName }}</p>
          </div>
          <div class="table-sort__td column-trade-type">
            <p>{{ item.tradingOperation }}</p>
          </div>
          <div class="table-sort__td column-departure-country">
            <template v-for="(country, index) in getList(item.departureCountries)" :key="country.id">
              {{ item.departureCountries.length != index + 1 ? `${country.name}, ` : country.name }} <br />
            </template>
            <span class="products-groups__count" v-if="getMissing(item.departureCountries)"
              >+{{ getMissing(item.departureCountries) }}</span
            >
          </div>
          <div class="table-sort__td column-destination-country">
            <template v-for="(country, index) in getList(item.destinationCountries)" :key="country.id">
              {{ item.destinationCountries.length != index + 1 ? `${country.name}, ` : country.name }} <br />
            </template>
            <span class="products-groups__count" v-if="getMissing(item.destinationCountries)"
              >+{{ getMissing(item.destinationCountries) }}</span
            >
          </div>
          <div class="table-sort__td column-status">
            <p>{{ getStatus(item.isActive) }}</p>
          </div>
          <div class="table-sort__td column-date-creation">
            <p>
              {{ $momentFormat(item?.created, 'DD.MM.YYYY') }}
              <br />
              {{ $momentFormat(item?.created, 'HH:mm') }}
            </p>
          </div>
          <div class="table-sort__td column-date-change">
            <p>
              {{ $momentFormat(item?.modified, 'DD.MM.YYYY') }}
              <br />
              {{ $momentFormat(item?.modified, 'HH:mm') }}
            </p>
          </div>
        </div>
        <div v-if="getTableInfo.items.length < 4" class="table-sort__row stub"></div>
        <div v-if="getTableInfo.items.length < 3" class="table-sort__row stub"></div>
        <div v-if="getTableInfo.items.length < 2" class="table-sort__row stub"></div>
      </div>
      <div v-else class="table-sort__body">
        <div class="table-sort__row stub">
          <div class="table-sort__td stub">
            <Loader v-if="getLoadPage" />
            <template v-else> По вашему запросу товары не найдены </template>
          </div>
        </div>
        <div class="table-sort__row stub"></div>
        <div class="table-sort__row stub"></div>
        <div class="table-sort__row stub"></div>
      </div>
    </div>

    <div v-if="getTableInfo.pagesTotal > 1" class="container-page big container-page--no-indentation">
      <PaginationRedesigned
        :pageCount="getTableInfo.pagesTotal"
        :currentPage="getTableInfo.pageNumber"
        :loadingMore="getLoadMore"
        @change="onPageChange"
        @more="onPageMore"
      />
    </div>

    <!-- подтверждение удаления -->
    <ModalInfo
      v-model="isOpenModalClarifying"
      titleModal="Вы действительно хотите удалить эту группу?"
      @closeModal="closeModalInfo('isOpenModalClarifying')"
    >
      <div class="content-modal-info">
        <div class="content-modal-info__button-wrap">
          <ButtonComponent @click="deleteCard">Удалить</ButtonComponent>
          <ButtonComponent @click="closeModalInfo('isOpenModalClarifying')" mod="gradient-bg">Отменить</ButtonComponent>
        </div>
      </div>
    </ModalInfo>

    <!-- успешное удаление или нет -->
    <ModalInfo
      v-model="isOpenModalInfo"
      @closeModal="closeModalInfo"
      :titleModal="titleModal"
      :textModal="textModal"
      :modalIconName="modalIconName"
    />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { debounce } from 'lodash';

  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import ModalInfo from '@/common/components/redesigned/ModalInfo.vue';
  import PageTitle from '@/common/components/redesigned/PageTitle.vue';
  import PaginationRedesigned from '@/common/components/redesigned/PaginationRedesigned.vue';
  import Constants from '@/common/constants';
  import modalInfo from '@/common/mixins/modalInfo';
  import IconComponent from '@/common/ui/IconComponent.vue';

  import Loader from '@/components/Loader.vue';

  import TableHeader from '../components/table/TableHeader.vue';
  import { NAVIGATOR_PRODUCT_GROUPS_ACTIONS_NAME, NAVIGATOR_PRODUCT_GROUPS_GETTERS_NAME } from '../store/productGroups';
  import { MODAL_INFO_MESSAGES } from '../utils/constants';

  export default {
    name: 'ProductGroups',
    components: {
      ButtonComponent,
      PaginationRedesigned,
      IconComponent,
      ModalInfo,
      PageTitle,
      TableHeader,
      Loader,
    },
    mixins: [modalInfo],
    data() {
      return {
        statusList: Constants.statusOptions,
        page: {
          pageNumber: 1,
          pageSize: 10,
        },
        filter: {
          codeTnved: '',
          nameTnved: '',
          tradingOperationId: '',
          countryDepartureIds: [],
          countryDestinationIds: [],
          isActive: '',
          createdFrom: '',
          createdTo: '',
          modifiedFrom: '',
          modifiedTo: '',
        },
        // sortColumn:
        // 0 - Код ТН ВЭД
        // 1 - Наименование товара
        // 2 - Тип торговой операции
        // 3 - Страна отправления
        // 4 - Страна назначения
        // 6 - Статус
        // 7 - Дата создания
        // 8 - Дата изменения
        sortColumn: 0,
        // sortOrder:
        // 0 - по возрастанию
        // 1 - по убыванию
        sortOrder: 0,
        isOpenModalClarifying: false,
        deleteItemID: 0,
        modalIconName: Constants.MODAL_INFO_ICON.ACCEPT,
        statusOptionsIDs: Constants.statusOptionsIDs,
        maxLength: 3,
      };
    },
    computed: {
      ...mapGetters({
        getTotalGoods: NAVIGATOR_PRODUCT_GROUPS_GETTERS_NAME.getTotalGoods,
        getLoadPage: NAVIGATOR_PRODUCT_GROUPS_GETTERS_NAME.getLoadPage,
        getLoadMore: NAVIGATOR_PRODUCT_GROUPS_GETTERS_NAME.getLoadMore,
        getTableInfo: NAVIGATOR_PRODUCT_GROUPS_GETTERS_NAME.getTableInfo,
      }),
    },
    created() {
      this.loadInfo();
    },
    methods: {
      getList(list) {
        return list.slice(0, this.maxLength);
      },
      getMissing(list) {
        if (list.length < this.maxLength) return 0;
        else return list.length - this.maxLength;
      },
      ...mapActions({
        fetchListGroups: NAVIGATOR_PRODUCT_GROUPS_ACTIONS_NAME.fetchListGroups,
        fetchMoreListGroups: NAVIGATOR_PRODUCT_GROUPS_ACTIONS_NAME.fetchMoreListGroups,
        deleteGroup: NAVIGATOR_PRODUCT_GROUPS_ACTIONS_NAME.deleteGroup,
      }),

      formatFilter() {
        const data = JSON.parse(JSON.stringify(this.filter));
        for (const key in data) {
          !data[key] && delete data[key];
        }

        if (!data?.isActive) data.isActive = [true, false];
        else data.isActive = [data.isActive == this.statusOptionsIDs.active];

        return data;
      },

      async loadInfo() {
        const data = this.formatFilter();
        await this.fetchListGroups({
          ...this.page,
          ...data,
          sortColumn: this.sortColumn,
          sortOrder: this.sortOrder,
        });
      },

      debounceChangeValue: debounce(function () {
        this.page.pageNumber = 1;
        this.loadInfo();
      }, 500),

      changeSorting(id) {
        if (this.sortColumn == id) this.sortOrder = this.sortOrder == 0 ? 1 : 0;
        else this.sortOrder = 0;
        this.sortColumn = id;
        this.loadInfo();
      },

      editCard(id) {
        this.$router.push({ name: 'ProductGroupsCard', params: { id, type: 'edit' } });
      },

      createCard() {
        this.$router.push({ name: 'ProductGroupsCard', params: { id: 0, type: 'create' } });
      },

      openClarifyingPopup(id) {
        this.deleteItemID = id;
        this.isOpenModalClarifying = true;
      },

      async deleteCard() {
        const res = await this.deleteGroup({ id: this.deleteItemID });
        if (res) {
          this.closeModalInfo('isOpenModalClarifying');
          this.isOpenModalInfo = true;
          this.titleModal = MODAL_INFO_MESSAGES.REMOVE_TITLE;
          if (res.success) {
            this.textModal = MODAL_INFO_MESSAGES.REMOVE_SUCCESS;
            this.modalIconName = Constants.MODAL_INFO_ICON.ACCEPT;
            this.page.pageNumber = 1;
            this.loadInfo();
          } else {
            this.textModal = MODAL_INFO_MESSAGES.REMOVE_ERROR;
            this.modalIconName = Constants.MODAL_INFO_ICON.ERROR;
          }
        }
      },

      getStatus(status) {
        return status ? this.statusList[0]?.text : this.statusList[1]?.text;
      },

      changeFilterDepartureCountry(val) {
        if (val) this.filter.countryDepartureIds = [Constants.countryRussiaId];
        else this.filter.countryDepartureIds = [];
      },

      changeFilterDestinationCountry(val) {
        if (val) this.filter.countryDestinationIds = [Constants.countryRussiaId];
        else this.filter.countryDestinationIds = [];
      },

      onPageChange(pageNumber) {
        this.page.pageNumber = pageNumber;
        this.loadInfo();
      },

      async onPageMore(pageNumber) {
        const data = this.formatFilter();
        this.page.pageNumber = pageNumber;
        await this.fetchMoreListGroups({
          ...this.page,
          ...data,
          sortColumn: this.sortColumn,
          sortOrder: this.sortOrder,
        });
      },
    },
    watch: {
      filter: {
        handler() {
          this.debounceChangeValue();
        },
        deep: true,
      },
    },
  };
</script>

<style scoped lang="scss">
  @import '@/assets/theme/default/content-modal-info.scss';
  @import '@/assets/theme/default/table/table-sort.scss';

  .products-groups {
    margin-bottom: 40px;

    &__count {
      display: inline-block;
      color: #fff;
      background: $blue;
      border-radius: 4px;
      padding: 2px 5px 2px 2px;
    }
  }
</style>
